/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step2title1Inputs */

const zh_landing_workflow_step2title1 = /** @type {(inputs: Landing_Workflow_Step2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一键生成并分享练习`)
};

const en_landing_workflow_step2title1 = /** @type {(inputs: Landing_Workflow_Step2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate exercises and share in one click`)
};

const es_landing_workflow_step2title1 = /** @type {(inputs: Landing_Workflow_Step2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera ejercicios y compártelos con un clic`)
};

/**
* | output |
* | --- |
* | "Generate exercises and share in one click" |
*
* @param {Landing_Workflow_Step2title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step2title1 = /** @type {((inputs?: Landing_Workflow_Step2title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step2title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step2title1(inputs)
	if (locale === "en") return en_landing_workflow_step2title1(inputs)
	return es_landing_workflow_step2title1(inputs)
});
export { landing_workflow_step2title1 as "landing_workflow_step2Title" }